<template>
  <div style="width: 100%; height: 100%">
    <div id="chartLineBox" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "DataCount",
  props: {
    lineList: Array,
    title: String,
  },
  data: () => ({
    msg: "Welcome to Your Vue.js App",
  }),

  mounted() {
    this.chartLine = echarts.init(document.getElementById("chartLineBox"));
    console.log(this.lineList);
    // 指定图表的配置项和数据
    var myDataList = this.lineList.map(function (item) {
      return item[1];
    });
    var CSI300DataList = this.lineList.map(function (item) {
      return item[2];
    });
    var DateList = this.lineList.map(function (item) {
      return item[0];
    });
    var c = CSI300DataList.concat(myDataList);
    console.log(c);
    if (c.length > 0) {
      var maxYAmount = Math.max.apply(null, c);
      var minYAmount = Math.min.apply(null, c);

      maxYAmount = Math.ceil(Math.abs(maxYAmount / 10)) * 10;
      minYAmount = Math.ceil(Math.abs(minYAmount / 10)) * 10;

      if (maxYAmount > minYAmount) {
        maxYAmount = maxYAmount;
        minYAmount = -maxYAmount;
      } else {
        maxYAmount = minYAmount;
        minYAmount = -minYAmount;
      }
      if (maxYAmount == "" && minYAmount == "") {
      }
      var interVal = (maxYAmount - minYAmount) / 4;
      var timeinterval = parseInt((DateList.length - 2) / 2);
    } else {
      var maxYAmount = 10;
      var minYAmount = -10;
      var interVal = (maxYAmount - minYAmount) / 4;
    }

    var option = {
      grid: {
        left: "3%",
        right: "6%",
        bottom: "5%",
        top: "28%",
        borderWidth: 0.5,
        containLabel: true,
      },
      title: {
        y: "10px",
        x: "20px",
        text: this.title + "最高收益",
        left: "13",
        textStyle: {
          color: "#333333", // 主标题文字的颜色。
          fontStyle: "normal", // 主标题文字字体的风格。 'normal'  'italic'  'oblique'
          fontWeight: "normal", // 主标题文字字体的粗细。 'normal' 'bold'  'bolder'  'lighter' 500|600
          fontFamily: "sans-serif", // 主标题文字的字体系列。
          fontSize: 16, // 字体大小
          lineHeight: "30", // 行高
          // width ... , // 文字块的宽度
          // height ... , // 文字块的高度
          textBorderColor: "transparent", // 文字本身的描边颜色。
          textBorderWidth: 0, // 文字本身的描边宽度。
          textShadowColor: "transparent", // 文字本身的阴影颜色。
          // textShadowBlur: 0, // 文字本身的阴影长度。
          // textShadowOffsetX: 0, // 文字本身的阴影 X 偏移。
          // textShadowOffsetY: 0, //  文字本身的阴影 Y 偏移。
        },
      },
      legend: {
        //设置区分（哪条线属于什么）
        icon: "plain",

        itemWidth: 10,
        padding: 15,
        itemGap: 25, // 图形宽度。
        itemHeight: 3,
        top: "8px",
        left: "right",

        data: ["本账户", "沪深300"],
      },
      color: ["#FD4E50", "#437DFA"], //设置区分（每条线是什么颜色，和 legend 一一对应）
      xAxis: {
        //设置x轴
        type: "category",
        boundaryGap: false, //坐标轴两边不留白
        data: DateList,
        handle: {
          show: true,
          color: "#fff",
          width: 0.2,
        },
        axisLine: {
          show: true,
          onZero: true,
          lineStyle: {
            color: "#EDEDED",
            width: 0.2,
          },
        },
        axisLabel: {
          showMaxLabel: true,
          showMinLabel: true,
          // show: true,
          interval: timeinterval,
          color: "#999999",
          formatter: function (val) {
            if (val == DateList[0]) {
              val = "        " + DateList[0];
              console.log(val, DateList.length / 2);
            } else if (val == DateList[DateList.length - 1]) {
              // console.log(val);
              val = DateList[DateList.length - 1] + "         ";
              console.log(val);
            }

            return val;
          },
        },
        // axisLine: {
        //   //坐标轴轴线相关设置。
        //   lineStyle: {
        //     show: false,
        //     color: "#D6D7DB",
        //   },
        // }
        axisTick: {
          // 坐标轴刻度相关设置
          show: false, // 是否显示坐标轴刻度。
          alignWithLabel: true, // 类目轴中在 boundaryGap 为 true
          // interval: false, // 坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成
          inside: false, // 坐标轴刻度是否朝内，默认朝外。
        },
        z: 0,
        splitLine: {
          show: true,
          lineStyle: {
            color: "#EDEDED",
            width: 0.5,
            type: "dashed", //虚线
          },
        },
      },
      yAxis: [
        {
          // name: "SALES VOLUME",
          min: minYAmount,
          max: maxYAmount,
          interval: interVal, //强制设置坐标轴分割间隔。
          nameTextStyle: {
            color: "#999",
            fontSize: 16,
            padding: [0, 0, 10, 0],
            lineStyle: {
              color: "#000",
              width: 0.5,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
              width: 0.5,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#ddd",
              width: 0.5,
              //虚线
            },
          },
          axisTick: {
            show: false,
            // inside: true
          },
          type: "value",
          axisLabel: {
            formatter: "{value}" + "%",
          },
        },
        {
          type: "value",
          // min: 0,
          // max: 300,
          // interval: 50,
          axisTick: {
            show: false,
            // inside: true
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
              width: 0.5,
            },
          },

          axisLabel: {
            show: false,
            textStyle: {
              // 在这里设置右边Y轴文字颜色
              color: "#ddd",
              width: 0.5,
            },
          },
        },
      ],
      series: [
        {
          name: "本账户",
          data: myDataList,
          type: "line",
          symbo: "none",
          showSymbol: false, // 类型为折线图
          lineStyle: {
            // 线条样式 => 必须使用normal属性
            normal: {
              color: "#FD4E50",
              width: 0.7,
            },
          },
        },
        {
          name: "沪深300",
          data: CSI300DataList,
          type: "line",
          showSymbol: false,
          lineStyle: {
            normal: {
              color: "#437DFA",
              width: 0.7,
            },
          },
        },
      ],
    };

    // 使用刚指定的配置项和数据显示图表。
    this.chartLine.setOption(option);
  },
};
</script>